export default __webpack_public_path__ + "static/img_welfare_5-fdedf67a1016baea749bb7c5a3ee64ae.jpg";